import { routes } from '../../router'

export const REQUEST_FOR_ANALYSIS_BREADCRUMBS = (title: string) => {
  return [
    {
      children: 'Contracts',
      href: '/contracts'
    },
    {
      children: 'Central repository',
      href: routes.contracts + routes.centralRepository
    },
    {
      children: 'Requests for analysis',
      href: routes.contracts + routes.centralRepository
    },
    {
      children: title
    }
  ]
}
export const REQUEST_FOR_ANALYSIS_BREADCRUMBS_COMMONS = (title: string) => {
  return [
    {
      children: 'Contracts',
      href: '/contracts'
    },
    {
      children: 'Opportunity analysis',
      href: routes.contracts + routes.opportunityAnalysis
    },
    {
      children: title
    }
  ]
}
